/* Blu scroll-on reveal
   Fades and lifts key homepage elements into view as they enter the
   viewport, with a gentle stagger between siblings. Respects
   prefers-reduced-motion and degrades to no-op without IntersectionObserver. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.blu-eyebrow',
    '.blu-heading',
    '.blu-hero__text',
    '.blu-hero__actions',
    '.blu-hero__media',
    '.blu-copy',
    '.blu-split__item',
    '.blu-split__grid > div:last-child',
    '.blu-mcard',
    '.blu-edit-card',
    '.blu-social__item',
    '.blu-feature__media',
    '.blu-feature__perk',
    '.blu-feature__price',
    '.blu-feature__text',
    '.blu-feature__form',
    '#shopify-section-featured_collection .card-wrapper'
  ];

  var els = Array.prototype.slice.call(
    document.querySelectorAll(SELECTORS.join(','))
  );
  if (!els.length) return;

  // Stagger siblings that share a parent (cards, chips, grid tiles)
  var counts = new Map();
  els.forEach(function (el) {
    var parent = el.parentElement;
    var i = counts.get(parent) || 0;
    counts.set(parent, i + 1);
    el.style.transitionDelay = Math.min(i * 90, 450) + 'ms';
    el.setAttribute('data-blu-reveal', '');
  });

  function cleanup(el) {
    // Hand transitions back to component styles (hover effects etc.)
    el.removeAttribute('data-blu-reveal');
    el.classList.remove('blu-revealed');
    el.style.transitionDelay = '';
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('blu-revealed');
        var delay = parseInt(el.style.transitionDelay, 10) || 0;
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          cleanup(el);
        };
        el.addEventListener('transitionend', finish, { once: true });
        setTimeout(finish, 900 + delay);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );

  els.forEach(function (el) {
    io.observe(el);
  });
})();
